import { NewsModel } from '@modules/news/news-model';

const { fields } = NewsModel;

export default [
  fields.id,
  fields.title,
  fields.subtitle,
  fields.contentHtml,
  fields.description,
  fields.media,
  fields.status,
  fields.propertyOwner,
  fields.createdAt
];
